import { QueryClientProvider } from '@tanstack/react-query'
import { AppRouter } from '@/routes'
import { ToastProvider } from '@/components/ui'
import { queryClient } from '@/lib/queryClient'

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AppRouter />
      </ToastProvider>
    </QueryClientProvider>
  )
}

export default App
